<template>

    <FloatingPanel>

        <div class="canvas-blocks-custom-projectSlider-BlockPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">

                <div slot="Algemeen">

                    <SwitchInput
                        label="Welke projecten tonen?"
                        instruction=""
                        :options="options"
                        options-property="customOrLatest"
                        :items="[
                            { value: 'custom', label: 'Zelf kiezen'},
                            { value: 'latest', label: 'Laatste projecten'},
                            { value: 'products', label: 'Op basis van toepassingen'},
                        ]"
                        defaultValue="latest"
                        :open="true"
                    />

                    <accordion-input :open="true" v-if="options.customOrLatest === 'products'">
                        <template #label>
                            <div class="font-medium text-gray-600">Product selectie</div>
                        </template>
                        <template #content>
                            <div class="flex items-center">
                                <select
                                    class="w-full px-4 py-3 mt-1 transition ease-in-out border border-gray-300 border-solid rounded-md focus:border-indigo-600 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                                    v-model="options['product_id']"
                                >
                                    <option value="">Selecteer een product</option>
                                    <option v-for="product in products" :key="product.id" :value="product.id">
                                        {{ product.name }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </accordion-input>

                </div>

                <div slot="Design">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        SwitchInput,
        AccordionInput,
        Tabs,
    },

    data() {
        return {
            products: [],
        }
    },

    created() {
        this.loadProducts();
    },

    methods: {
        async loadProducts() {
            this.products = (await axios.get(this.adminUrlPrefix + '/getProducts')).data;
        },
    },

}

</script>
